// extracted by mini-css-extract-plugin
export default {"overlay":"aFMK0NRcLZdbeOxxJvC6"};